import React from 'react';
import { useMutation } from '@apollo/client';
import { Card, Form, Input, InputNumber, Switch, Button, message } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { createExploreCategory } from '../../graphql/mutation';
import './Explore.css';

const CreateCategory = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [createCategory, { loading }] = useMutation(createExploreCategory, {
    onCompleted: () => {
      message.success('Category created successfully');
      navigate('/explore');
    },
    onError: (error) => message.error(error.message)
  });

  const onFinish = (values) => {
    createCategory({
      variables: {
        input: {
          name: values.name,
          order: values.order || 0,
          isActive: values.isActive ?? true
        }
      }
    });
  };

  return (
    <div className="explore-container">
      <div className="page-header">
        <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate('/explore')}
          style={{ marginBottom: 16 }}
        >
          Back to Explore
        </Button>
        <h1 className="page-title">Create Category</h1>
        <p className="page-subtitle">Add a new explore category</p>
      </div>

      <Card className="explore-card" style={{ maxWidth: 600 }}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ order: 0, isActive: true }}
        >
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: 'Please enter category name' }]}
          >
            <Input placeholder="Category name" />
          </Form.Item>

          <Form.Item
            name="order"
            label="Order"
          >
            <InputNumber min={0} style={{ width: '100%' }} placeholder="Display order" />
          </Form.Item>

          <Form.Item
            name="isActive"
            label="Active"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Create Category
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default CreateCategory;
